import { EpgDateFilter } from '../models/epgData';

/**
 * Create a time string array based on the dates and the interval in mins
 *
 * @param startDate
 * @param endDate
 * @param intervalMins
 * @returns
 */
export const generateTimeArray = (startDate: string, endDate: string, intervalMins: number): string[] => {
  try {
    const intervalMs = intervalMins * 60000; //1800000
    const startTimeEpoch = new Date(startDate).getTime();
    const endTimeEpoch = new Date(endDate).getTime();
    const length = Math.ceil((endTimeEpoch - startTimeEpoch) / intervalMs);
    return Array.from({ length }, (_, index) => {
      const time = startTimeEpoch + index * intervalMs;
      const date = new Date(time);
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const period = hours < 12 ? 'AM' : 'PM';
      const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
      return `${formattedHours}:${minutes} ${period}`;
    });
  } catch (_) {
    return [];
  }
};

/**
 * Get an array dates
 *
 * @param daysInPast
 * @param daysInFuture
 * @returns
 */
export const getDates = (daysInPast: number, daysInFuture: number, initDate?: string): EpgDateFilter[] => {
  const currentDate = new Date().setHours(0, 0, 0, 0);
  const totalDays = daysInPast + 1 + daysInFuture;
  return Array.from({ length: totalDays }, (_, index) => {
    const dayOffset = index - daysInPast;
    const date = new Date(currentDate + dayOffset * 86400000);
    return { date, active: initDate ? date.toISOString() === initDate : index === daysInPast, isToday: index === daysInPast };
  });
};
